export default function (Component) {
Component.options.__tip = "<p>You can use the <code>sync</code>-modifier on the <code>selectedIds</code>-prop in order to be informed when the selection changes.</p>\n"
}